export const config = {
    stakeInputType: "number"
};
//# sourceMappingURL=config.js.map